/** CA announcement Countdown Block - independent of Dawn's slideshow component. */
if (!customElements.get('ra-announcement-countdown')) {
  class RaAnnouncementCountdown extends HTMLElement {
    connectedCallback() {
      // Connected callbacks also fire when the Shopify editor re-renders this block.
      this.stop();

      const endTime = new Date(this.dataset.endTime || '').getTime();
      if (!Number.isFinite(endTime)) return;

      const label = this.querySelector('[data-countdown-label]');
      const days = this.querySelector('[data-countdown-days]');
      const hours = this.querySelector('[data-countdown-hours]');
      const minutes = this.querySelector('[data-countdown-minutes]');
      const seconds = this.querySelector('[data-countdown-seconds]');
      if (!label || !days || !hours || !minutes || !seconds) return;

      const defaultLabel = this.dataset.defaultLabel || '';
      const todayLabel = this.dataset.todayLabel || 'SALE ENDS TODAY';
      const soonLabel = this.dataset.soonLabel || 'SALE ENDS SOON';
      const endedLabel = this.dataset.endedLabel || 'SALE ENDED';
      const dynamicLabel = this.dataset.enableDynamicLabel === 'true';
      const pad = (value) => String(value).padStart(2, '0');

      const update = () => {
        let distance = endTime - Date.now();
        if (distance <= 0) {
          days.textContent = '00';
          hours.textContent = '00';
          minutes.textContent = '00';
          seconds.textContent = '00';
          label.textContent = endedLabel;
          this.stop();
          return;
        }

        const totalHours = distance / 3600000;
        const remainingDays = Math.floor(distance / 86400000);
        distance %= 86400000;
        const remainingHours = Math.floor(distance / 3600000);
        distance %= 3600000;
        const remainingMinutes = Math.floor(distance / 60000);
        distance %= 60000;
        const remainingSeconds = Math.floor(distance / 1000);

        days.textContent = pad(remainingDays);
        hours.textContent = pad(remainingHours);
        minutes.textContent = pad(remainingMinutes);
        seconds.textContent = pad(remainingSeconds);

        if (dynamicLabel) {
          label.textContent = totalHours <= 1
            ? soonLabel
            : totalHours <= 24 ? todayLabel : defaultLabel;
        } else {
          label.textContent = defaultLabel;
        }
      };

      // Render immediately, then update once a second while this node exists.
      update();
      if (endTime > Date.now()) this._countdownInterval = window.setInterval(update, 1000);
    }

    disconnectedCallback() {
      this.stop();
    }

    stop() {
      if (this._countdownInterval !== undefined) {
        window.clearInterval(this._countdownInterval);
        this._countdownInterval = undefined;
      }
    }
  }

  customElements.define('ra-announcement-countdown', RaAnnouncementCountdown);
}
